(function () {
  function buildSelect(id, from, to, step, fmt) {
    var sel = document.getElementById(id);
    if (!sel) return;
    sel.innerHTML = '<option value="">—</option>';
    for (var v = from; v <= to + 0.0001; v += step) {
      v = Math.round(v * 10000) / 10000;
      var opt = document.createElement('option');
      opt.value = String(v);
      opt.textContent = fmt(v);
      sel.appendChild(opt);
    }
  }
  function fmtSph(v) { return (v > 0 ? '+' : '') + v.toFixed(2); }
  function fmtDec(v) { return v.toFixed(2); }
  function fmtInt(v) { return String(Math.round(v)); }
  function fmtPd(v)  { return v.toFixed(1); }

  function populate() {
    ['bdBlSphR',  'bdBlSphL'].forEach(function(id) { buildSelect(id, -20, 20,  0.25, fmtSph); });
    ['bdBlCylR',  'bdBlCylL'].forEach(function(id) { buildSelect(id,  -6,  0,  0.25, fmtDec); });
    ['bdBlAxisR', 'bdBlAxisL'].forEach(function(id) { buildSelect(id,   0, 180, 1,   fmtInt); });
    ['bdBlPdR',   'bdBlPdL'].forEach(function(id)  { buildSelect(id,  20,  40, 0.5, fmtPd);  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', populate);
  } else {
    populate();
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('bdBlueLightModal');
  if (!modal) return;

  // Move to <body> to avoid stacking-context issues from nested product-form elements
  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var ADDON_VARIANTS = {
    zeiss_blue:   53239478780231,
    plus_blue:    53239473963335,
    blue_control: 53779401867591,
  };

  var panel = modal.querySelector('.bd-modal__panel');

  // Bei Epos (bzw. Tag "no-plano"): keine Plano-Variante -> Schritt 1 überspringen
  var noPlano = modal.getAttribute('data-bl-no-plano') === 'true';

  var stepChoice  = document.getElementById('bdBlStep1');
  var stepCardsRx = document.getElementById('bdBlStep2Rx');
  var stepNoRx    = document.getElementById('bdBlStep2NoRx');
  var stepRx      = document.getElementById('bdBlStepRx');
  var stepEnter   = document.getElementById('bdBlStepRxEnter');
  var stepUpload  = document.getElementById('bdBlStepRxUpload');

  var sphR  = document.getElementById('bdBlSphR');
  var sphL  = document.getElementById('bdBlSphL');
  var cylR  = document.getElementById('bdBlCylR');
  var cylL  = document.getElementById('bdBlCylL');
  var axisR = document.getElementById('bdBlAxisR');
  var axisL = document.getElementById('bdBlAxisL');
  var pdR   = document.getElementById('bdBlPdR');
  var pdL   = document.getElementById('bdBlPdL');
  var rxFile = document.getElementById('bdBlRxFile');

  var productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('product-form form') ||
    document.querySelector('form[action^="/cart/add"]');
  if (!productForm) return;

  var selectedLens = null;
  var selectedPrice = '0';
  var selectedAddonVariant = null;
  var isAdding = false;

  // --- Steps ---
  function hideAll() {
    [stepChoice, stepCardsRx, stepNoRx, stepRx, stepEnter, stepUpload].forEach(function(s) {
      if (s) s.style.display = 'none';
    });
    if (panel) panel.classList.remove('bd-modal--wide');
  }

  function show(el, wide) {
    hideAll();
    if (el) el.style.display = 'block';
    if (wide && panel) panel.classList.add('bd-modal--wide');
  }

  function openModal() {
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden', 'false');
    resetState();
    if (noPlano) {
      // Direkt zur Gläserauswahl; Default-Paket vorwählen, damit "Weiter" ohne Klick geht
      show(stepCardsRx, false);
      var preCard = document.querySelector('#bdBlCardList .bd-compare-card[data-bl-lens="zeiss_blue"]');
      if (preCard) preCard.click();
    } else {
      show(stepChoice);
    }
  }

  function closeModal() {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }

  function resetState() {
    selectedLens = null;
    selectedPrice = '0';
    selectedAddonVariant = null;
    document.querySelectorAll('input[name="bdBlLensType"]').forEach(function(i) { i.checked = false; });
    document.querySelectorAll('input[name="bdBlRxMethod"]').forEach(function(i) { i.checked = false; });
    document.querySelectorAll('#bdBlCardList .bd-compare-card').forEach(function(c) {
      c.classList.remove('bd-compare-card--selected');
    });
    if (rxFile) rxFile.value = '';
    var step1Next = document.getElementById('bdBlStep1Next');
    if (step1Next) step1Next.disabled = true;
    var cardsNext = document.getElementById('bdBlCardsNext');
    if (cardsNext) { cardsNext.disabled = true; cardsNext.textContent = 'Weiter →'; }
    var rxNext = document.getElementById('bdBlRxNext');
    if (rxNext) rxNext.disabled = true;
    var warn = document.getElementById('bdBlLaterWarning');
    if (warn) warn.style.display = 'none';
  }

  // --- Cart helpers ---
  function setProp(name, value) {
    var inputName = 'properties[' + name + ']';
    productForm.querySelectorAll('input[name="' + CSS.escape(inputName) + '"]').forEach(function(el) { el.remove(); });
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = inputName;
    inp.value = value;
    inp.setAttribute('data-bd-bl-prop', '1');
    productForm.appendChild(inp);
  }

  function clearProps() {
    // Remove bluelight props AND any props set by the main bd-lens-modal to avoid interference
    productForm.querySelectorAll('input[data-bd-bl-prop="1"], input[data-bd-prop="1"]').forEach(function(el) { el.remove(); });
  }

  function formatSPH(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    return (n > 0 ? '+' : '') + n.toFixed(2);
  }

  function lensName(key) {
    // Bevorzugt den sichtbaren Kartennamen (bei Epos ohne "ZEISS"), sonst Fallback.
    var card = document.querySelector('.bd-compare-card[data-bl-lens="' + key + '"]');
    if (card && card.getAttribute('data-name')) return card.getAttribute('data-name');
    if (key === 'zeiss_blue') return 'ZEISS Blue Protect';
    if (key === 'plus_blue')  return 'Blue Ray';
    return 'Blue Control';
  }

  async function addNoRx() {
    if (isAdding) return;
    isAdding = true;
    try {
      var variantEl = productForm.querySelector('input[name="id"]');
      var mainVariantId = variantEl ? variantEl.value : null;
      if (!mainVariantId) throw new Error('Kein Variant ID gefunden.');
      var props = {};
      productForm.querySelectorAll('input[data-bd-bl-prop="1"]').forEach(function(inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = inp.value;
      });
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(mainVariantId, 10), quantity: 1, properties: props }),
      });
      if (!res.ok) throw new Error(await res.text());
      window.location.href = '/cart';
    } catch (err) {
      console.error('[BD Bluelight noRx]', err);
      alert('Ups – etwas hat nicht geklappt. Bitte erneut versuchen.');
      isAdding = false;
    }
  }

  async function addToCart() {
    if (isAdding) return;
    isAdding = true;
    try {
      var variantEl = productForm.querySelector('input[name="id"]');
      var mainVariantId = variantEl ? variantEl.value : null;
      if (!mainVariantId) throw new Error('Kein Variant ID gefunden.');

      // Eindeutige Paar-ID damit zwei identische Varianten im Warenkorb korrekt zugeordnet werden
      var pairId = Date.now().toString(36) + Math.random().toString(36).substr(2, 4);

      // Collect only our own properties (avoid empty static bdLensProps inputs)
      var props = {};
      productForm.querySelectorAll('input[data-bd-bl-prop="1"]').forEach(function(inp) {
        var m = inp.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = inp.value;
      });
      props['_pair'] = pairId;

      var hasFile = rxFile && rxFile.files && rxFile.files.length;
      var res;
      if (hasFile) {
        var fd = new FormData();
        fd.set('id', mainVariantId);
        fd.set('quantity', '1');
        Object.keys(props).forEach(function(k) { fd.set('properties[' + k + ']', props[k]); });
        fd.set('properties[Sehtest Upload]', rxFile.files[0]);
        res = await fetch('/cart/add', {
          method: 'POST', body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
      } else {
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(mainVariantId, 10), quantity: 1, properties: props }),
        });
      }
      if (!res.ok) throw new Error(await res.text());

      if (selectedAddonVariant) {
        var resAddon = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: selectedAddonVariant, quantity: 1,
            properties: {
              '_pair': pairId,
              'Add-on für Variant': String(mainVariantId),
              'Add-on für Produkt': document.title || 'Brille',
            },
          }),
        });
        if (!resAddon.ok) throw new Error(await resAddon.text());
      }

      window.location.href = '/cart';
    } catch (err) {
      console.error('[BD Bluelight]', err);
      alert('Ups – etwas hat nicht geklappt. Bitte erneut versuchen.');
      isAdding = false;
    }
  }

  // --- Trigger button ---
  document.querySelectorAll('[data-open-bluelight-modal]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); openModal(); });
  });

  // --- Close on backdrop ---
  modal.addEventListener('click', function(e) {
    if (e.target && e.target.hasAttribute('data-bd-bl-close')) closeModal();
  });

  // --- STEP 1: Radio selection → enable Weiter ---
  document.querySelectorAll('input[name="bdBlLensType"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var next = document.getElementById('bdBlStep1Next');
      if (next) next.disabled = false;
    });
  });

  var step1Next = document.getElementById('bdBlStep1Next');
  if (step1Next) step1Next.addEventListener('click', function() {
    var choice = document.querySelector('input[name="bdBlLensType"]:checked');
    if (!choice) return;
    if (choice.value === 'rx') {
      // Default-Paket: Blue Protect vorausgewählt, damit "Weiter" ohne Klick möglich ist
      var zeissCard = document.querySelector('#bdBlCardList .bd-compare-card[data-bl-lens="zeiss_blue"]');
      if (zeissCard) zeissCard.click();
      show(stepCardsRx, false);
    } else {
      selectedLens = 'blue_control';
      selectedPrice = '0';
      selectedAddonVariant = null;
      show(stepNoRx, false);
    }
  });

  // --- STEP 2a: Card selection ---
  document.querySelectorAll('#bdBlCardList .bd-compare-card').forEach(function(card) {
    card.addEventListener('click', function() {
      document.querySelectorAll('#bdBlCardList .bd-compare-card').forEach(function(c) {
        c.classList.remove('bd-compare-card--selected');
      });
      card.classList.add('bd-compare-card--selected');
      selectedLens = card.getAttribute('data-bl-lens');
      selectedPrice = card.getAttribute('data-price') || '0';
      selectedAddonVariant = ADDON_VARIANTS[selectedLens] || null;
      var next = document.getElementById('bdBlCardsNext');
      if (next) {
        next.disabled = false;
        var name = card.getAttribute('data-name') || '';
        var priceLabel = selectedPrice === '0' ? 'Inklusive' : '+CHF ' + selectedPrice;
        next.textContent = name + ' (' + priceLabel + ') →';
      }
    });
  });

  var cardsBack = document.getElementById('bdBlCardsBack');
  if (cardsBack) cardsBack.addEventListener('click', function() {
    if (noPlano) { closeModal(); } else { show(stepChoice); }
  });

  var cardsNext = document.getElementById('bdBlCardsNext');
  if (cardsNext) cardsNext.addEventListener('click', function() {
    if (!selectedLens) return;
    show(stepRx);
    var rxNext = document.getElementById('bdBlRxNext');
    if (rxNext) rxNext.disabled = true;
    document.querySelectorAll('input[name="bdBlRxMethod"]').forEach(function(i) { i.checked = false; });
    var warn = document.getElementById('bdBlLaterWarning');
    if (warn) warn.style.display = 'none';
  });

  // --- STEP 2b: Blue Control ---
  var noRxBack = document.getElementById('bdBlNoRxBack');
  if (noRxBack) noRxBack.addEventListener('click', function() { show(stepChoice); });

  var noRxAdd = document.getElementById('bdBlNoRxAdd');
  if (noRxAdd) noRxAdd.addEventListener('click', function() {
    clearProps();
    setProp('Gläserpaket', 'Blue Control');
    setProp('Gläserpaket Aufpreis (CHF)', selectedPrice);
    setProp('Rx Method', 'Ohne Sehstärke');
    closeModal();
    addNoRx();
  });

  // --- STEP 3: Rx Method ---
  document.querySelectorAll('input[name="bdBlRxMethod"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var next = document.getElementById('bdBlRxNext');
      if (next) next.disabled = false;
      var warn = document.getElementById('bdBlLaterWarning');
      if (warn) warn.style.display = radio.value === 'later' ? 'block' : 'none';
    });
  });

  var rxBack = document.getElementById('bdBlRxBack');
  if (rxBack) rxBack.addEventListener('click', function() { show(stepCardsRx, true); });

  var rxNext = document.getElementById('bdBlRxNext');
  if (rxNext) rxNext.addEventListener('click', function() {
    var method = document.querySelector('input[name="bdBlRxMethod"]:checked');
    if (!method) return;
    if (method.value === 'upload') {
      show(stepUpload);
      var upNext = document.getElementById('bdBlUploadNext');
      if (upNext) upNext.disabled = !(rxFile && rxFile.files && rxFile.files.length);
    }
    if (method.value === 'later') {
      clearProps();
      setProp('Gläserpaket', lensName(selectedLens));
      setProp('Gläserpaket Aufpreis (CHF)', selectedPrice);
      setProp('Sehstärke', 'Wird später per E-Mail eingereicht');
      closeModal();
      addToCart();
    }
  });

  // --- STEP 4a: Enter values ---
  function validateEnter() {
    var ok = sphR && sphR.value && sphR.value !== '' &&
             sphL && sphL.value && sphL.value !== '' &&
             pdR  && pdR.value  && pdR.value  !== '' &&
             pdL  && pdL.value  && pdL.value  !== '';
    var next = document.getElementById('bdBlEnterNext');
    if (next) next.disabled = !ok;
  }

  [sphR, sphL, pdR, pdL, cylR, cylL, axisR, axisL].forEach(function(el) {
    if (!el) return;
    el.addEventListener('change', validateEnter);
  });

  var enterBack = document.getElementById('bdBlEnterBack');
  if (enterBack) enterBack.addEventListener('click', function() { show(stepRx); });

  var enterNext = document.getElementById('bdBlEnterNext');
  if (enterNext) enterNext.addEventListener('click', function() {
    clearProps();
    setProp('Gläserpaket', lensName(selectedLens));
    setProp('Gläserpaket Aufpreis (CHF)', selectedPrice);
    setProp('Sehstärke übermittelt', 'Eingabe');
    if (sphR  && sphR.value  !== '') setProp('SPH Rechts',   formatSPH(sphR.value));
    if (sphL  && sphL.value  !== '') setProp('SPH Links',    formatSPH(sphL.value));
    if (pdR   && pdR.value   !== '') setProp('PD Rechts',    pdR.value + ' mm');
    if (pdL   && pdL.value   !== '') setProp('PD Links',     pdL.value + ' mm');
    if (cylR  && cylR.value  !== '') setProp('CYL Rechts',   cylR.value);
    if (cylL  && cylL.value  !== '') setProp('CYL Links',    cylL.value);
    if (axisR && axisR.value !== '') setProp('Achse Rechts', axisR.value + '°');
    if (axisL && axisL.value !== '') setProp('Achse Links',  axisL.value + '°');
    closeModal();
    addToCart();
  });

  // --- STEP 4b: Upload ---
  if (rxFile) rxFile.addEventListener('change', function() {
    var next = document.getElementById('bdBlUploadNext');
    if (next) next.disabled = !(rxFile.files && rxFile.files.length);
    var fname = document.getElementById('bdBlUploadFilename');
    if (fname && rxFile.files && rxFile.files.length) fname.textContent = rxFile.files[0].name;
  });

  var uploadBack = document.getElementById('bdBlUploadBack');
  if (uploadBack) uploadBack.addEventListener('click', function() { show(stepRx); });

  var uploadNext = document.getElementById('bdBlUploadNext');
  if (uploadNext) uploadNext.addEventListener('click', function() {
    if (!(rxFile && rxFile.files && rxFile.files.length)) return;
    clearProps();
    setProp('Gläserpaket', lensName(selectedLens));
    setProp('Gläserpaket Aufpreis (CHF)', selectedPrice);
    setProp('Sehstärke übermittelt', 'Sehtest Upload');
    if (!productForm.contains(rxFile)) productForm.appendChild(rxFile);
    if (!productForm.getAttribute('enctype')) productForm.setAttribute('enctype', 'multipart/form-data');
    rxFile.name = 'properties[Sehtest Upload]';
    closeModal();
    addToCart();
  });
});
